/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useRef, useLayoutEffect } from 'react';
import { BsSquare, BsCheckSquare } from 'react-icons/bs';
import { status } from './constant';

export default function Checkbox1(props) {
    const {
        indeterminate, checked, id, compute, name,
    } = props;
    const inputRef = useRef(null);
    useLayoutEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate;
            inputRef.current.checked = checked;
        }
    }, [indeterminate, checked]);

    return (
        <input
            ref={inputRef}
            type="checkbox"
            className="bg-[#F5F5FA]"
            id={name}
            onChange={() => {
                const newStatus = inputRef.current.checked
                    ? status.checked
                    : status.unchecked;
                compute(id, newStatus);
            }}
        />

    );
}
